import { useState, useEffect } from "react";
import clsx from "clsx";
import styles from "./STCookies.module.css";
import { Icons } from "@/const/icons";
import { STButton } from "../STButton";
import { STModal } from "../STModal";

export const STCookies = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  // modal
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Small delay to ensure the entry animation triggers smoothly after mount
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
  };

  const handleAnimationEnd = () => {
    if (isClosing) {
      setIsVisible(false);
    }
  };

  const handleAcceptAll = () => {
    localStorage.setItem("cookieConsent", "accepted");
    handleClose();
  };

  const handleRejectAll = () => {
    localStorage.setItem("cookieConsent", "rejected");
    handleClose();
  };

  const handleSaveCustom = () => {
    localStorage.setItem("cookieConsent", "custom");
    setOpen(false);
    handleClose();
  };

  if (!isVisible && !isClosing) return null;
  return (
    <>
      <div
        className={clsx(
          styles.cookiesWrapper,
          "position-fixed bottom-0 start-0 end-0 w-100 bg-clr-white",
          isVisible && !isClosing && styles.slideUp,
          isClosing && styles.slideDown,
        )}
        onAnimationEnd={handleAnimationEnd}
      >
        <div className="container">
          <div
            className={clsx(
              "d-flex align-items-center justify-content-between gap-sm flex-column flex-lg-row",
            )}
          >
            <p className={clsx("h6 mb-0 d-flex align-items-center gap-2")}>
              <span className="flex-shrink-0">{Icons.cookieIcon}</span>
              We use cookies to refine your experience - you’re always in
              control.
            </p>
            <div
              className={clsx(
                styles.cookiesBtnWrapper,
                "d-flex flex-wrap flex-sm-nowrap justify-content-center",
              )}
            >
              <STButton variant="outline-black" onClick={handleRejectAll}>
                Reject all
              </STButton>
              <STButton variant="black" onClick={() => setOpen(true)}>
                Customise
              </STButton>
              <STButton variant="primary" onClick={handleAcceptAll}>
                Accept all
              </STButton>
            </div>
          </div>
        </div>
      </div>
      {/* modal */}
      <STModal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Customize cookies"
        isNotFooter
        modalBodyClassName="py-0"
      >
        <ul className={clsx(styles.toggleSwitchList)}>
          <li className="d-flex align-items-center gap-xs justify-content-between">
            <div>
              <h5 className="fw-medium p text-black">Strictly Necessary</h5>
              <p className="fw-normal p sm text-clr-gray mb-0">Required for core functionality like security, login, and page navigation.</p>
            </div>
            <label class="toggle">
              <input class="toggle-checkbox" type="checkbox" />
              <div class="toggle-switch"></div>
            </label>
          </li>
          <li className="d-flex align-items-center gap-xs justify-content-between">
            <div>
              <h5 className="fw-medium p text-black">Analytics / Performance</h5>
              <p className="fw-normal p sm text-clr-gray mb-0">Helps us understand how visitors interact with the site.</p>
            </div>
            <label class="toggle">
              <input class="toggle-checkbox" type="checkbox" />
              <div class="toggle-switch"></div>
            </label>
          </li>
          <li className="d-flex align-items-center gap-xs justify-content-between">
            <div>
              <h5 className="fw-medium p text-black">Marketing / Advertising</h5>
              <p className="fw-normal p sm text-clr-gray mb-0">Used to deliver personalized ads and measure campaign effectiveness.</p>
            </div>
            <label class="toggle">
              <input class="toggle-checkbox" type="checkbox" />
              <div class="toggle-switch"></div>
            </label>
          </li>
          <li className="d-flex align-items-center gap-xs justify-content-between">
            <div>
              <h5 className="fw-medium p text-black">Functional / Preferences</h5>
              <p className="fw-normal p sm text-clr-gray mb-0">Remembers your settings like language, region, and theme etc.</p>
            </div>
            <label class="toggle">
              <input class="toggle-checkbox" type="checkbox" />
              <div class="toggle-switch"></div>
            </label>
          </li>
        </ul>
        <div className="d-flex justify-content-end mt-4 mb-2">
          <STButton variant="primary" onClick={handleSaveCustom}>
            Save Preferences
          </STButton>
        </div>
      </STModal>
    </>
  );
};
